import { store } from "../../app/store/store";
import req from "../../axios/interceptedAxiosInstance";
import { successToast } from "../../notification/notification";

export const resize = (file, WIDTH) =>
  new Promise((resolve) => {
    if (file) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.addEventListener("load", (e) => {
        const image_url = e.target.result;
        const image = document.createElement("img");
        image.src = image_url;

        image.addEventListener("load", (e) => {
          const canvas = document.createElement("canvas");
          const ratio = WIDTH / e.target.width;
          canvas.width = WIDTH;
          canvas.height = e.target.height * ratio;

          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, canvas.width, canvas.height);

          const new_image_url = context.canvas.toDataURL();
          const image_file = base64ToImage(new_image_url);
          const url = uploadToCloudinary(image_file);
          resolve(url);
        });
      });
    }
  });

const base64ToImage = (url) => {
	console.log(url)
  const urlArr = url.split(",");
  const mime = urlArr[0].match(/:(.*?);/)[1];
  const data = urlArr[1];

  const dcryptData = atob(data);
  let length = dcryptData.length;
  let dataArr = new Uint8Array(length);

  while (length--) {
    dataArr[length] = dcryptData.charCodeAt(length);
  }

  const file = new File([dataArr], "file.jpeg", { type: mime });
  return file;
};

const uploadToCloudinary = async (file) => {
  const payload = new FormData();
  payload.append("file", file);

  try {
    const response = await req.post("user/upload", payload);
    const url = await sendUrlToServer(response.data.data.secure_url);
    return url;
  } catch (error) {
    console.log(error);
  }
};

const sendUrlToServer = async (cloudinaryUrl) => {
  try {
    const response = await req.put(
      `profile/update/${store.getState().user.user.data.id}`,
      { profile_image: cloudinaryUrl }
    );
    successToast("successfully saved");
    return response.data.data.profile_image;
  } catch (error) {
    console.log(error);
  }
};
